module.exports = __webpack_public_path__ + "static/pic06-05653d205a36da91b3161519999f69c1.jpg";